export default __webpack_public_path__ + "static/media/edit_white.fe4c7d67.svg";